import {
    Component,
    Input,
    SimpleChanges,
} from '@angular/core';
import { FormGroup } from '@angular/forms';

export enum TokenType {
    TokenToro,
    SMS,
    Email,
};

const tokenToroIconPath = "/assets/svg-icons/ic_key_token_toro_red.svg";
const shieldIconPath = "/assets/svg-icons/ic_shield_token_red.svg";

@Component({
    selector: 'validate-token',
    templateUrl: './validate-token.component.html',
    styleUrls: ['./validate-token.component.scss'],
})
export class ValidateTokenComponent {
    @Input()
    public formGroup: FormGroup;

    @Input()
    public onSubmit: () => void;

    @Input()
    public onSmsRequest: () => void;

    @Input()
    public onEmailRequest: () => void;

    @Input()
    public onReturnTokenToro: () => void;

    @Input()
    public onToggleRemember: () => void;

    @Input()
    public onHowToUse: () => void;

    @Input()
    public onContactProblem: () => void;

    @Input()
    public timer: number = 0;

    @Input()
    public showRemeberCheckbox: boolean = false;

    @Input()
    public allowEmail: boolean = false;

    @Input()
    public busy: boolean = false;

    @Input()
    public tokenType: TokenType;

    @Input()
    public tokenField: string;

    @Input()
    public rememberTokenField: string;

    @Input()
    public userLastPhoneNumbers: string;

    @Input()
    public userOffuscatedEmail: string;

    @Input()
    public user: string;

    private _tokenLabel: string;
    public set tokenLabel(val: string) {
        this._tokenLabel = `Digite o ${val}`;
    }
    public get tokenLabel() {
        return this._tokenLabel;
    }
    public resendLabel: string;

    public title: string;
    public subTitle: string;
    public subTitleBold?: string;
    public linkText: string;
    public onLinkClick: () => void;

    public iconPath: string;
    public iconClass: string;

    public minLength: number;
    public maxLength: number;

    public showSmsAlert: boolean = false;
    public showOptionsAccordeon: boolean = true;
    public showCodeResend: boolean = false;

    public onResend: () => void;

    constructor() {
        this.updateScreen(this.tokenType);
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.tokenType) {
            const { currentValue, previousValue } = changes.tokenType;

            if (currentValue != previousValue) {
                this.updateScreen(currentValue);
            }
        }
    }

    private updateScreen(tokenType: TokenType) {
        this.tokenLabel = tokenType === TokenType.TokenToro ? "Token Toro" : "código";
        this.resendLabel = tokenType === TokenType.SMS ? "SMS" : "e-mail";
        this.title = tokenType === TokenType.TokenToro
            ? "Digite o Token Toro disponível no aplicativo da Toro"
            : "Digite o código recebido";
        this.subTitle = tokenType === TokenType.TokenToro
            ? "O Token é um código de segurança de 6 números gerado no aplicativo."
            : tokenType === TokenType.Email
                ? `Enviamos um código de segurança para o e-mail:`
                : `Enviamos um código de segurança para o número com final:`;
        this.subTitleBold = tokenType === TokenType.TokenToro
            ? undefined
            : tokenType === TokenType.Email
                ? this.userOffuscatedEmail
                : this.userLastPhoneNumbers;
        this.linkText = tokenType === TokenType.TokenToro
            ? "Como acesso o Token Toro?"
            : tokenType === TokenType.Email ? "Problemas com meu e-mail" : "Problemas com meu celular";
        this.onLinkClick = tokenType === TokenType.TokenToro
            ? this.onHowToUse
            : this.onContactProblem;

        this.iconPath = tokenType === TokenType.TokenToro ? tokenToroIconPath : shieldIconPath;
        this.iconClass = tokenType === TokenType.TokenToro ? 'token-toro-icon' : 'token-toro-icon shield';

        this.maxLength = tokenType === TokenType.TokenToro ? 6 : 5;
        this.minLength = tokenType === TokenType.TokenToro ? 6 : 5;

        this.showSmsAlert = tokenType === TokenType.SMS;
        this.showOptionsAccordeon = tokenType === TokenType.TokenToro;
        this.showCodeResend = tokenType !== TokenType.TokenToro;

        this.onResend = tokenType === TokenType.SMS ? this.onSmsRequest : this.onEmailRequest;
    }
}
